import { getNestedProperty } from '@opallabs/lambda'
import { ContextCollection, Context, State, StateKeys } from '../../../../types'

type Entity = 'moment' | 'story'
type GetContexts = (state: State) => ContextCollection | undefined
type GetContextByEntityId = (
  state: State,
  entity: Entity,
  id: string
) => Context | undefined

export const getContexts: GetContexts = (state) =>
  getNestedProperty<ContextCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.context
  )

export const getContextByEntityId: GetContextByEntityId = (
  state,
  entity,
  id
) => {
  const contexts = getNestedProperty<ContextCollection>(
    state,
    'jsonApiEntities',
    'context'
  )
  if (contexts !== undefined) {
    return Object.values(contexts).find(
      (context: Context) =>
        getNestedProperty<string>(context, 'relationships', entity, 'id') ===
        `${id}`
    )
  }

  return undefined
}
